import React from 'react';
import generateCSSGlobalVariables, { defaultColors } from '../../utils/cssGlobalVariables';
import queries from '../../utils/query';
import { cssVariables, selectCssVariables } from '../../redux/cssVariablesSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useMutation, useQuery } from '@apollo/client';
import { createStandaloneToast } from '@chakra-ui/react';

const CanvasCSSVariablesImport = ({ viewId }) => {
	const dispatch = useDispatch();
	const cssVar = useSelector(cssVariables);
	const [buffer, setBuffer] = React.useState(null);
	const { loading, error, data } = useQuery(queries.GET_VIEW_CSS_VARIABLES(viewId));
	const toast = createStandaloneToast();
	const [updateViewCssVariables, __] = useMutation(queries.UPDATE_VIEW_CSS_VARIABLES);

	//fazer por req
	React.useEffect(() => {
		if (data) {
			const cssVarJson = data?.viewCssVariables?.cssVariables;
			let cssVarJsonObj;
			if (cssVarJson) {
				if (cssVarJson == '{}') {
					cssVarJsonObj = { ...defaultColors };
					updateViewCssVariables({
						variables: {
							viewId: String(viewId),
							cssVariables: JSON.stringify(cssVarJsonObj),
						},
					});
				} else {
					cssVarJsonObj = JSON.parse(cssVarJson);
				}
				dispatch(selectCssVariables(generateCSSGlobalVariables(cssVarJsonObj)));
			} else {
				toast(cssVarError);
			}
		}
	}, [data]);

	//apollo error
	React.useEffect(() => {
		if (error) {
			toast(cssVarError);
		}
	}, [error]);

	React.useEffect(() => {
		if (!cssVar) return;

		const keys = Object.keys(cssVar);

		const str = `
            :root,:host,::before,::after{
                ${keys.map((key) => `${key}:${cssVar[key]}`).join(';')}
            }
        `;
		setBuffer(str);
	}, [cssVar]);

	// if(!buffer || loading) return null
	return <style>{buffer}</style>;
};

export default CanvasCSSVariablesImport;

const cssVarError = {
	title: `Ocorreu um erro ao tentar recuperar as variáveis de estilo`,
	status: 'error',
	duration: 10000,
	isClosable: true,
	position: 'top',
};
